import React, { useEffect } from 'react'
import { Link,useLocation } from 'react-router-dom'
import './LatestNews.css'
import banner from '../../assets/images/News Banner.png' 
import news1 from '../../assets/images/news1.jpg'
import news2 from '../../assets/images/news2.png'
import aos from 'aos';
import 'aos/dist/aos.css'

const LatestNews = () => {
  const { top } = useLocation();
  useEffect(()=>{
    aos.init({ duration: 1000 });
    window.scrollTo(0,0);
  },[top])
  return (
    <>
       <div className="container-fluid gx-0">
                <img className='img-fluid' data-aos="zoom-in" src={banner} alt="" />
        </div>
        <div className="container py-lg-5 py-3">
            <div className="row">
              <div className="col-lg-4 pe-5">
                        <h6 className='news-heading' data-aos="zoom-in">Latest News</h6><hr className='news-hr'/>
                        <ul className='all-link-container news-link-container list-unstyled' data-aos="zoom-in">

                            <li><Link to="https://www.pharmaceuticals.gov.in/whats-new" className='articles-link'>https://www.pharmaceuticals.gov.in/whats-new</Link></li><hr/>

                            <li><Link to="https://www.pharmabiz.com/" className='articles-link'>https://www.pharmabiz.com/</Link></li><hr/>

                            <li><Link to="https://www.indianpharmapost.com/" className='articles-link'>https://www.indianpharmapost.com/</Link></li><hr/>
                           
                        </ul>

                </div>
              
              <div className="col-lg-8 col-md-8">
                <div className="row">
                  <div className="col-12">
                    <div className="news-card" data-aos="zoom-in">
                      <div className="news-img">
                        <img className='img-fluid' src={news1} alt="" />
                      </div>
                      <div className="news-content">
                        <h6>News</h6>
                         <Link className='news-link'> 
                         <h4>PM Modi launches and inaugurates Rs. 12,850 crore health projects at AIIA, New Delhi</h4>
                         </Link>

                          <p>These initiatives signify a substantial boost to healthcare infrastructure across India, aligned with the Prime Minister’s mission of ensuring quality healthcare services nationwide</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 mt-5 ">
                    <div className="news-card" data-aos="zoom-in">
                      <div className="news-img">
                        <img className='img-fluid' src={news2} alt="" />
                      </div>
                      <div className="news-content">
                        <h6>News</h6>
                         <Link className='news-link'> 
                         <h4>CDSCO, NRAI meets WHO international standards for vaccine regulations</h4>
                         </Link>

                          <p>The Central Drugs Standard Control Organisation (CDSCO), along with the National Regulatory Authority of India (NRA) and affiliated institutions, has been found to meet the World Health Organization (WHO) published indicators for a functional vaccine regulatory system.</p>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>   
        </div>
    </>
  )
}

export default LatestNews
